module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-mob-2.cdb23ec4.jpg";